// src/components/guide/QuestPanel.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Circle } from 'lucide-react';
import { useGuide } from '../../contexts/GuideContext';

export default function QuestPanel({ onClose }) {
  const guide = useGuide();
  const { state, activation } = guide;
  const list = state.activated ? state.habits : state.milestones;
  return <section className="guide-panel" aria-label="Your activation quest" data-guide-ui>
    <header><span className="v2-eyebrow">{state.activated ? 'KEEP THE LOOP TURNING' : 'YOUR ACTIVATION QUEST'}</span><strong>{state.activated ? 'Build the habit' : `${state.completed} of 6 — ${state.next?.label}`}</strong></header>
    <ol className="guide-quest">{list.map(item => <li key={item.id} className={item.done ? 'done' : item.id === state.next?.id ? 'current' : ''}>
      {item.done ? <Check size={14} aria-hidden="true"/> : <Circle size={14} aria-hidden="true"/>}
      <span>{item.label}{item.optional && <small> · optional</small>}<span className="sr-only">{item.done ? ' (done)' : ''}</span></span>
    </li>)}</ol>
    {state.next && <div className="guide-quest-next"><p>{state.next.hint}</p>{state.next.show && <button type="button" className="v2-button" onClick={() => { onClose(); guide.showMilestone(state.next.id); }}>Show me</button>}</div>}
    <footer>
      <Link to="/welcome" onClick={onClose}>Replay intro</Link>
      {activation.sample_ids.length > 0 && <button type="button" className="v2-text-action" data-guide="sample-clear" onClick={() => guide.setConfirmClear(true)}>Clear sample product</button>}
      <button type="button" className="v2-text-action" onClick={() => { onClose(); guide.setPaused(true); }}>Pause guide</button>
    </footer>
  </section>;
}
